import React from 'react'

const Icon = () => {
  return (
    <svg width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.8 7.00065L8.66667 9.66732H7.06667L6 8.14332L4.93333 9.66732H3.33333L5.2 7.00065L3.33333 4.33398H4.93333L6 5.85798L7.06667 4.33398H8V1.66732H1.33333V12.334H10.6667V4.33398H8.66667L6.8 7.00065ZM0 0.995318C0 0.629984 0.298 0.333984 0.666 0.333984H8.66667L12 3.66732V12.996C12.0006 13.0835 11.984 13.1703 11.951 13.2515C11.9181 13.3326 11.8695 13.4064 11.808 13.4688C11.7466 13.5311 11.6734 13.5807 11.5928 13.6148C11.5121 13.6489 11.4255 13.6667 11.338 13.6673H0.662C0.486919 13.6661 0.319345 13.5961 0.195478 13.4723C0.0716119 13.3486 0.00139643 13.1811 0 13.006V0.995318Z'
        fill='#686867'
      />
    </svg>
  )
}

export default Icon
